import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

//REST-API
//local
// export const REST_URI = "http://localhost:8080";
//dev
// export const REST_URI = "https://stsn-stage-q5c6brgtqa-el.a.run.app";
//prod
export const REST_URI = "https://stsn-prod-q5c6brgtqa-el.a.run.app";


//RAZORPAY-KEY
//dev
export const RAZORPAY_KEY = "rzp_test_R1E4A2whW7RqSn";
//prod
// export const RAZORPAY_KEY = "rzp_live_lhpcAL8o4iO0Yz";


//GRAPHQL
const client = new ApolloClient({
  link: new HttpLink({
    //local
    // uri: "http://localhost:8080/graphql",
    //dev
    // uri:'https://stsn-stage-q5c6brgtqa-el.a.run.app/graphql',
    //prod
    uri:'https://stsn-prod-q5c6brgtqa-el.a.run.app/graphql'
  }),
  cache: new InMemoryCache(),
});

export default client;
